import React from 'react';
import PropTypes from 'prop-types';

import { BRANDS_FOR_DROPDOWN } from 'lib/networking/endpoints';
import SearchableScrollableSelect from 'components/shared/SearchableScrollableSelect';

function BrandSearchSelect({
  value,
  onChange,
  isInvalid = false,
  placeholder = 'Search and select brand...',
}) {
  return (
    <SearchableScrollableSelect
      autoFocus={false}
      initOption={value}
      onChange={onChange}
      fetchUrl={BRANDS_FOR_DROPDOWN}
      optionMapper={brand => ({ label: `${brand.name} (ID: ${brand.id})`, value: brand.id })}
      placeholder={placeholder}
      disabled={false}
      menuPortalTarget={document.body}
    />
  );
}

BrandSearchSelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isInvalid: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default BrandSearchSelect;
